module.exports = __webpack_public_path__ + "media/images/ringrevenue/dropdown_grey-68bb953e6b56771b84adb4c281bbd9e6.gif";